// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/room_requirements.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_feature_hotel_hotel_types } from "./hotel_types_pb";

/**
 * Describes the file proto/model/feature/hotel/room_requirements.proto.
 */
export const file_proto_model_feature_hotel_room_requirements = /*@__PURE__*/
  fileDesc("CjFwcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL3Jvb21fcmVxdWlyZW1lbnRzLnByb3RvEgZjYXJtZW4iywEKEFJvb21SZXF1aXJlbWVudHMSKAoJcm9vbV90eXBlGAEgASgOMhUuY2FybWVuLkhvdGVsUm9vbVR5cGUSIQoIYmVkX3R5cGUYAiABKA4yDy5jYXJtZW4uQmVkVHlwZRIQCghxdWFudGl0eRgDIAEoBRIaChJyZXF1aXJlZF9hbWVuaXRpZXMYBCADKAkSIgoaYWNjZXNzaWJpbGl0eV9yZXF1aXJlbWVudHMYBSADKAkSGAoQc3BlY2lhbF9yZXF1ZXN0cxgGIAMoCUI2WjRnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsYgZwcm90bzM", [file_proto_model_feature_hotel_hotel_types]);

/**
 * Describes the message carmen.RoomRequirements.
 * Use `create(RoomRequirementsSchema)` to create a new message.
 */
export const RoomRequirementsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_room_requirements, 0);

